import $ from 'jquery'

const initLazyLoad= function() {
  require(['lazyload/lazyload.js'], () => {
    lazyload()
  })
}

$(document).ready(function(){
  initLazyLoad()
})



// WEBPACK FOOTER //
// ./src/components/lazyimg/index.js